<template>
    
</template>

<script>
    export default {
        name: "Triforce"
    }
</script>

<style scoped>

</style>